<template>
  <div class="tech-achievements-container">
    <div class="title">科技成果</div>
    <div class="scroll-container" ref="scrollContainer">
      <div class="scroll-content" ref="scrollContent">
        <div v-for="(item, index) in techItems" :key="index" class="tech-item">
          <div class="tech-image-container">
            <img v-if="item && item.image" :src="item.image" :alt="item.cooperationUnit" class="tech-image">
            <div v-else class="tech-image-placeholder">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
          <div class="tech-info">
            <div class="company-name">{{ item.techServiceAchievement }}</div>
            <div class="divider-line"></div>
            <div class="project-name">【科技特派员】{{ item.scienceTechnician }}</div>
            <div class="project-name">【对接单位】{{ item.cooperationUnit }}</div>

            <!--            <div class="project-details">-->
<!--              <span v-for="(detail, idx) in item.details" :key="idx" class="detail-item">-->
<!--                {{ detail.label }}：{{ detail.value }}-->
<!--              </span>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TechAchievementController from '../../../api/Controller/TechAchievementController'
import { uploadMixin } from '@/core/mixins'

export default {
  name: 'TechAchievements',
  mixins: [uploadMixin],
  data () {
    return {
      // 技术成果数据
      techItems: [],
      scrollTimer: null,
      scrollSpeed: 1 // 滚动速度
    }
  },
  mounted () {
    this.fetchTechAchievements()
  },
  methods: {
    // 获取技术成果数据
    fetchTechAchievements () {
      TechAchievementController.list(this, {})
        .then(res => {
          // console.log('技术成果数据:', res)

          // 处理API响应，兼容dataList和list格式
          let techAchievements = []
          if (res.data && res.data.dataList) {
            techAchievements = res.data.dataList
          } else if (res.data && res.data.list) {
            techAchievements = res.data.list
          } else if (res.data) {
            techAchievements = res.data
          }

          // 转换数据格式以匹配前端组件需求
          const formattedItems = techAchievements.map(item => {
            // 构建details数组
            const details = []
            if (item.cooperationUnit) details.cooperationUnit = item.cooperationUnit
            if (item.scienceTechnician) details.scienceTechnician = item.scienceTechnician
            if (item.techServiceAchievement) details.techServiceAchievement = item.techServiceAchievement

            // 处理图片URL，参考Specialists.vue的逻辑
            let image = require('../../../assets/img/bigScreen/qiye.png')
            if (item.imageUrl) {
              try {
                const imageItems = this.parseUploadData(item.imageUrl, {id: item.id, fieldName: 'imageUrl', asImage: true});
                if (imageItems && imageItems.length > 0) {
                  image = imageItems[0].url;
                }
              } catch (e) {
                console.error('解析图片数据失败:', e);
              }
            }

            return {
              image: image,
              ...details
            }
          })

          // 处理空数据情况，参考Specialists.vue的逻辑
          if (formattedItems.length > 0) {
            // 复制数据实现无缝滚动
            this.techItems = [...formattedItems, ...formattedItems]
          } else {
            console.warn('没有获取到技术成果数据');
            // 如果没有数据，使用默认数据
            const defaultItem = {
              image: require('../../../assets/img/bigScreen/qiye.png'),
              cooperationUnit: '暂无成果数据',
              techServiceAchievement: '',
              scienceTechnician: ''
            };
            this.techItems = [defaultItem, defaultItem]
          }

          // 数据加载完成后开始滚动
          this.startScroll()
        })
        .catch(error => {
          console.error('获取技术成果数据失败:', error)

          // 错误时使用默认数据，参考Specialists.vue的逻辑
          const defaultItem = {
            image: require('../../../assets/img/bigScreen/qiye.png'),
            cooperationUnit: '获取数据失败',
            techServiceAchievement: '',
            scienceTechnician: ''
          };
          this.techItems = [defaultItem, defaultItem]
          this.startScroll()
        })
    },
    startScroll () {
      const scrollContainer = this.$refs.scrollContainer
      const scrollContent = this.$refs.scrollContent

      if (!scrollContainer || !scrollContent) return

      this.scrollTimer = setInterval(() => {
        scrollContainer.scrollTop += this.scrollSpeed

        // 当滚动到原始数据的一半时，无缝跳回开头
        // 这样可以实现平滑的无缝滚动
        if (scrollContainer.scrollTop >= scrollContent.scrollHeight / 2) {
          scrollContainer.scrollTop = 0
        }
      }, 30)
    },
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    }
  },

  beforeDestroy () {
    this.stopScroll()
  }
}
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  color: #ffd700;
  text-align: center;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px #2c2c2c, 0 0 10px #ffd700, 0 0 20px #ffd700;
  -webkit-text-stroke: 1px #333;
  //padding: 5px 15px;
}
.tech-achievements-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

.scroll-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-content {
  width: 100%;
  padding-right: 20px;
  box-sizing: border-box;
}

.tech-item {
        display: flex;
        margin-bottom: 10px;
        margin-left: 10px;
        padding: 5px 0 5px 0;
        background: rgba(1, 19, 13, 0.4);
        border-radius: 8px;
        border: 1px solid rgba(115, 221, 255, 0.2);
      }

.tech-image-container {
  width: 120px;
  height: 100px;
  background-image: url(../../../assets/img/bigScreen/img_box.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  padding: 0px;
  box-sizing: border-box;
}

.tech-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.tech-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 185, 183, 0.1);
  border-radius: 4px;
}

.tech-image-placeholder i {
  font-size: 40px;
  color: rgba(1, 185, 183, 0.5);
}

.tech-info {
  flex: 1;
}

.company-name {
  color: #73DDFF;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.divider-line {
  height: 1px;
  background-color: rgba(115, 221, 255, 0.5);
  margin-bottom: 8px;
}

.project-name {
  color: #73DDFF;
  font-size: 13px;
  margin-bottom: 8px;
}

.project-details {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.detail-item {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}
</style>
